import React from 'react';
import { getMessage } from 'utils';
import DisplayError from './display-error';

export default class ErrorBoundary extends React.Component<
  {},
  { hasError: boolean; detail: Error; error: Error }
> {
  constructor(props) {
    super(props);
    this.state = { hasError: false, detail: null, error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, detail: error };
  }

  componentDidCatch(_, errorInfo) {
    // You can also log the error to an error reporting service
    this.setState({ hasError: true, error: errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <>
          <button
            style={{ height: 50, width: 200, margin: 20 }}
            onClick={() => window.location.reload()}
          >
            {getMessage('common.reload')}
          </button>
        </>
      );
    }
    return this.props.children;
  }
}
